<template>
    <v-flex xs4>
        <v-flex class="notifydropdown" v-click-outside="hideDropdown">
            <v-flex class="notifydropdown__select"  data-qe-id="notification-toggle_dropdown" @click="showHideDropdown()">
                {{getDisplayText()}}
            </v-flex>
            <v-flex v-if="showDropdown" tag="ul" class="ul-items inner-scrollbar">
                <v-flex tag="li">
                    {{notificationConstants.DONT_NOTIFY_ME}}
                    <v-checkbox
                        v-model="doNotNotifyCheckbox"
                        data-qe-id="do-not-notify_checkbox"
                        :readonly="doNotNotifyCheckbox"
                        color="ypo_blue"
                        v-on:change="click()"></v-checkbox>
                </v-flex>
                <v-flex tag="li">
                    {{renameNewActivity ? notificationConstants.NEW_ACTIVITY :notificationConstants.HOME_NEWSFEED}}
                    <v-checkbox v-model="allMembersCheckbox" data-qe-id="all-members_checkbox" color="ypo_blue" v-on:change="click()"></v-checkbox>
                </v-flex>
                <v-flex tag="li" v-if="!renameNewActivity">
                    {{notificationConstants.ALL_COMMUNITY_CONVERSATIONS}}
                    <v-checkbox v-model="allCommunitiesCheckbox" color="ypo_blue" v-on:change="click()"></v-checkbox>
                    <v-flex tag="ul" class="sub-heads-block">
                        <v-flex tag="li" class="sub-heads-list" v-if="forums.length > 0">
                            <div class="sub-head">{{privacySettingsConstants.MY_FORUMS}} ({{forums.length}})
                                <v-checkbox v-model="allForumsCheckbox" data-qe-id="all-forum_checkbox" color="ypo_blue" v-on:change="click()"></v-checkbox>
                            </div>
                            <v-flex tag="ul">
                                <v-flex tag="li" v-for="(forum, index) in forums" :key="forum.id">
                                    <label>{{forum.name}}</label>
                                    <v-checkbox v-model="selections[forum.id]" :data-qe-id="`forum-${index}_checkbox`" color="ypo_blue" v-on:change="click()"></v-checkbox>
                                </v-flex>
                            </v-flex>
                        </v-flex>
                        <v-flex tag="li" class="sub-heads-list" v-if="chapters.length > 0">
                            <div class="sub-head">{{privacySettingsConstants.MY_CHAPTERS}} ({{chapters.length}})<v-checkbox data-qe-id="all-chapter_checkbox" v-model="allChaptersCheckbox" color="ypo_blue" v-on:change="click()"></v-checkbox>
                            </div>
                            <v-flex tag="ul">
                                <v-flex tag="li" v-for="chapter in chapters" :key="chapter.id">
                                    <label>{{chapter.name}}</label>
                                    <v-checkbox v-model="selections[chapter.id]" :data-qe-id="`chapter-${index}_checkbox`" color="ypo_blue" v-on:change="click()"></v-checkbox>
                                </v-flex>
                            </v-flex>
                        </v-flex>
                        <v-flex tag="li" class="sub-heads-list" v-if="networks.length > 0">
                            <div class="sub-head">{{privacySettingsConstants.MY_NETWORKS}} ({{networks.length}})
                                <v-checkbox v-model="allNetworksCheckbox" data-qe-id="all-chapter_checkbox" color="ypo_blue" v-on:change="click()"></v-checkbox>
                            </div>
                            <v-flex tag="ul">
                                <v-flex tag="li" v-for="network in networks" :key="network.id">
                                    <label>{{network.name}}</label>
                                    <v-checkbox v-model="selections[network.id]" :data-qe-id="`network-${index}_checkbox`" color="ypo_blue" v-on:change="click()"></v-checkbox>
                                </v-flex>
                            </v-flex>
                        </v-flex>
                        <v-flex tag="li" class="sub-heads-list" v-if="regions.length > 0">
                            <div class="sub-head">{{privacySettingsConstants.MY_REGIONS}} ({{regions.length}})
                                <v-checkbox v-model="allRegionsCheckbox" data-qe-id="all-region_checkbox" color="ypo_blue" v-on:change="click()"></v-checkbox>
                            </div>
                            <v-flex tag="ul">
                                <v-flex tag="li" v-for="region in regions" :key="region.id">
                                    <label>{{region.name}}</label>
                                    <v-checkbox v-model="selections[region.id]" :data-qe-id="`region-${index}_checkbox`" color="ypo_blue" v-on:change="click()"></v-checkbox>
                                </v-flex>
                            </v-flex>
                        </v-flex>
                        <v-flex tag="li" class="sub-heads-list" v-if="groups.length > 0">
                            <div class="sub-head">{{privacySettingsConstants.MY_GROUPS}} ({{groups.length}})
                                <v-checkbox v-model="allGroupsCheckbox" data-qe-id="all-groups_checkbox" color="ypo_blue" v-on:change="click()"></v-checkbox>
                            </div>
                            <v-flex tag="ul">
                                <v-flex tag="li" v-for="group in groups" :key="group.id">
                                    <label>{{group.name}}</label>
                                    <v-checkbox v-model="selections[group.id]" :data-qe-id="`group-${index}_checkbox`" color="ypo_blue" v-on:change="click()"></v-checkbox>
                                </v-flex>
                            </v-flex>
                        </v-flex>
                    </v-flex>
                </v-flex>
            </v-flex>
        </v-flex>
    </v-flex>
</template>

<script>
    import { privacySettingsConstants, notificationConstants } from "./privacysettings.constants.js";
    import orderBy from "lodash/orderBy";
    import ClickOutside from "vue-click-outside";

    export default {
        name: "NotifyMeFor",
        data: () => ({
            showDropdown: false,
            privacySettingsConstants,
            notificationConstants,
            forums: [],
            chapters: [],
            networks: [],
            regions: [],
            groups: [],
            allMembersCheckbox: false,
            renameActivity: false,
            selections: {},
        }),
        methods: {
            getDisplayText() {
                if (this.allMembersCheckbox && this.getSelectedCommunities().length > 0 && !this.renameNewActivity) {
                    return 'Home Newsfeed and any selected communities';
                } else if (this.allMembersCheckbox && this.renameNewActivity) {
                    return 'New Activity';
                } else if (this.allMembersCheckbox) {
                    return 'Home Newsfeed';
                } else if (this.doNotNotifyCheckbox) {
                    return 'Don\'t Notify Me';
                }
                return 'Any selected communities';
            },
            showHideDropdown() {
                this.showDropdown = !this.showDropdown;
            },
            hideDropdown() {
                this.showDropdown = false;
            },
            initializeCommunityTypes() {
                this.forums = this.sortCommunitiesByAsc(this.communities.filter(i => i.recordTypeName === this.privacySettingsConstants.FORUM));
                this.chapters = this.sortCommunitiesByAsc(this.communities.filter(i => i.recordTypeName === this.privacySettingsConstants.CHAPTER));
                this.networks = this.sortCommunitiesByAsc(this.communities.filter(i => i.recordTypeName === this.privacySettingsConstants.NETWORK));
                this.regions = this.sortCommunitiesByAsc(this.communities.filter(i => i.recordTypeName === this.privacySettingsConstants.REGION));
                this.groups = this.sortCommunitiesByAsc(this.communities.filter(i => i.recordTypeName === this.privacySettingsConstants.GROUP));
            },
            initializeSelectionData() {
                this.allMembersCheckbox = this.notifyAllMembers;
                this.renameActivity = this.renameNewActivity;
                const selections = {};
                this.notifySelectedCommunities.forEach((community) => {
                    selections[community.communityId] = community.showSelected;
                });
                this.selections = selections;
            },
            getSelectedCommunities() {
                return this.communities.filter(community => this.selections[community.id]);
            },
            getCommunities() {
                return Object.keys(this.allCommunityIds).map((key) => {
                    return { communityId: this.allCommunityIds[key], showSelected: this.selections[this.allCommunityIds[key]] };
                });
            },
            sortCommunitiesByAsc(communities) {
                return orderBy(communities, "name", "asc");
            },
        },
        props: {
            communities: {
                type: Array,
                required: true,
            },
            click: {
                type: Function,
                required: true,
            },
            notifyAllMembers: {
                type: Boolean,
                required: true,
            },
            notifySelectedCommunities: {
                type: Array,
                required: true,
            },
            renameNewActivity: {
                type: Boolean,
                required: true,
            },
        },
        created() {
            this.initializeCommunityTypes();
            this.initializeSelectionData();
        },
        computed: {
            /* helpers */
            allCommunityIds() {
                return this.communities.map(x => x.id);
            },
            forumIds() {
                return this.forums.map(x => x.id);
            },
            chapterIds() {
                return this.chapters.map(x => x.id);
            },
            networkIds() {
                return this.networks.map(x => x.id);
            },
            regionIds() {
                return this.regions.map(x => x.id);
            },
            groupIds() {
                return this.groups.map(x => x.id);
            },
            /* checkbox management */
            doNotNotifyCheckbox: {
                set(value) {
                    this.allMembersCheckbox = !value;
                    this.allCommunitiesCheckbox = !value;
                },
                get() {
                    return !this.allMembersCheckbox && 
                    (this.allCommunityIds.every(communityId => !this.selections[communityId]) || this.renameNewActivity);
                },
            },
            allCommunitiesCheckbox: {
                set(value) {
                    const newSelections = {};
                    this.allCommunityIds.forEach((communityId) => {
                        newSelections[communityId] = value;
                    });
                    this.selections = newSelections;
                },
                get() {
                    return this.allCommunityIds.every(communityId => this.selections[communityId]);
                },
            },
            allNetworksCheckbox: {
                set(value) {
                    const newSelections = { ...this.selections };
                    this.networkIds.forEach((communityId) => {
                        newSelections[communityId] = value;
                    });
                    this.selections = newSelections;
                },
                get() {
                    return this.networkIds.every(communityId => this.selections[communityId]);
                },
            },
            allForumsCheckbox: {
                set(value) {
                    const newSelections = { ...this.selections };
                    this.forumIds.forEach((communityId) => {
                        newSelections[communityId] = value;
                    });
                    this.selections = newSelections;
                },
                get() {
                    return this.forumIds.every(communityId => this.selections[communityId]);
                },
            },
            allChaptersCheckbox: {
                set(value) {
                    const newSelections = { ...this.selections };
                    this.chapterIds.forEach((communityId) => {
                        newSelections[communityId] = value;
                    });
                    this.selections = newSelections;
                },
                get() {
                    return this.chapterIds.every(communityId => this.selections[communityId]);
                },
            },
            allRegionsCheckbox: {
                set(value) {
                    const newSelections = { ...this.selections };
                    this.regionIds.forEach((communityId) => {
                        newSelections[communityId] = value;
                    });
                    this.selections = newSelections;
                },
                get() {
                    return this.regionIds.every(communityId => this.selections[communityId]);
                },
            },
            allGroupsCheckbox: {
                set(value) {
                    const newSelections = { ...this.selections };
                    this.groupIds.forEach((communityId) => {
                        newSelections[communityId] = value;
                    });
                    this.selections = newSelections;
                },
                get() {
                    return this.groupIds.every(communityId => this.selections[communityId]);
                },
            },
        },
        directives: {
            ClickOutside,
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../common/styles/_colors.scss";

    .notifications {
        background: $white;

        header {
            color: $ypo-blue;
            font-family: Raleway;
            font-size: 22px;
            font-weight: 600;
            letter-spacing: -0.3px;
            line-height: 42px;
            padding: 20px 0px 0px 28px;
        }

        span {
            color: $ypo-dark-gray;
            font-family: Raleway;
            font-size: 16px;
            font-weight: 600;
            letter-spacing: 0.09px;
            line-height: 24px;
            margin: 30px;
            padding-left: 55px;
        }

        .member {
            color: $ypo-blue;
            font-family: "Noto Sans";
            font-size: 16px;
            font-weight: bold;
            letter-spacing: -0.18px;
            line-height: 40px;
            border-bottom: 1px solid $ypo-text-border;
            padding: 15px 0 0px 0;
            margin-bottom: 15px;

            .membertext {
                font-size: 20px;
            }
        }

        .options {
            padding: 0;

            &__row {
                position: relative;
                position: relative;
                margin: 0 0 10px 0 !important;
                background: $ypo-extra-light-gray;
                padding: 5px 0px;

                &:nth-child(2n + 1) {
                    background: transparent;
                }
            }

            strong {
                color: $black;
                font-family: "Noto Sans";
                font-size: 16px;
                font-weight: bold;
                letter-spacing: 0.29px;
                line-height: 24px;
            }

            .desc {
                padding: 0px;
                font-size: 14px;
            }

            .box {
                display: inline-block;
            }

            .notify {
                padding: 0 0 0 0;
                margin: 0 0 0 0;
            }
        }
    }

    .footer {
        background-color: $ypo-tile-border;
        position: absolute;
        left: 0;
        right: 0;
        padding: 20px 10px;
        margin-top: 30px;
    }

    .notifydropdown {
        padding: 0 !important;

        &__select {
            border-bottom: 1px solid $ypo-medium-gray;
            margin-bottom: 10px;
            padding: 0 !important;
            font-size: 16px;
            position: relative;
            cursor: pointer;

            @media (max-width: 767px){
                margin-right: 15px;
            }
            &:after {
                content: "\f0dd";
                position: absolute;
                right: 3px;
                font-family: "Font Awesome 5 Free";
                font-size: 20px;
                font-weight: 900;
                top: -3px;
                line-height: normal;
                pointer-events: none;
            }
        }

        ul {
            list-style: none;
            padding: 0 !important;

            &.ul-items {
                border: 1px solid $ypo-medium-gray;
                background: $white;
                border-radius: 4px;
                position: absolute;
                z-index: 1;
                width: 350px;
                max-height: 330px;
                overflow-y: auto;
                right: 0;
            }

            li {
                border-bottom: 1px solid $ypo-medium-gray;
                position: relative;
                padding: 12px 5px !important;
                font-weight: 600;
                color: $ypo-blue;

                label {
                    overflow: hidden;
                    display: block;
                    width: 80%;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }

                .v-input {
                    position: absolute;
                    right: 5px;
                    top: 8px;
                }

                .sub-heads-list {
                    padding: 0 !important;

                    ul {
                        padding-left: 40px !important;
                        background: $ypo-extra-light-gray;

                        li {
                            border: none;
                        }

                        .v-input {
                            right: 0px;
                        }
                    }

                    .sub-head {
                        background: $ypo-light-gray-background;
                        padding: 10px 30px;

                        .v-input {
                            right: 0px;
                            top: 10px;
                        }
                    }
                }
            }
        }
    }

    @media (max-width: 767px){
        .notifydropdown {
            &__select {
                font-size: 13px;
            }
        }
    }


    .container.grid-list-md .layout .flex {
        padding: 0px;
    }
</style>
